import { useProfielImage } from "app/hooks/configurator/useProfielImage";
import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";
import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { OptionTemplate } from "shared/api/middleware-api-client";
import { SelectionWrapper } from "widgets/configurator/door-options-controls/SelectionWrapper";
import { ProfielSelectorItem } from "./ProfielSelectorItem";

export const ProfielSelector = () => {
  // Layout options
  const {
    doorLayoutOptions,
    color,
    layout,
    updateLayout,
    getConfigurationProduct,
  } = useConfigurationOptionsContext();

  // Use analytics
  const { onConfig } = useAnalytics();

  // Profiel images
  const { generateImageId } = useProfielImage({});

  // Onclick handler
  // Change layout + update the configuration analytics
  const onChangeLayout = (layout: OptionTemplate) => {
    updateLayout(layout);

    const product = getConfigurationProduct();
    if (product)
      onConfig({
        ...product,
        doorLayout: {
          id: layout.id,
          name: layout.name,
          code: layout.code,
          description: layout.description,
          imageId: layout.imageId,
        },
      });
  };

  // Get color code
  const colorCode = color?.code ?? "";

  return (
    <SelectionWrapper className="gg-mt-3">
      {doorLayoutOptions.map((doorLayout: OptionTemplate, id) => {
        // IsActive state
        const isActive = doorLayout.code === layout?.code;

        const imageId = generateImageId(doorLayout.code, colorCode);
        return (
          <ProfielSelectorItem
            key={doorLayout.id + id}
            doorLayout={doorLayout}
            onChangeLayout={onChangeLayout}
            imageSource={imageId}
            isActive={isActive}
          />
        );
      })}
    </SelectionWrapper>
  );
};
